import React from 'react'
import { Link } from 'react-router-dom'
import Style from './Grouping.module.css'

const Grouping = (props) => {
    const supplierId=props.supId
    const colorList = [ 
        '#f7fdff ','#fff5f5','#fcfff1','#fff8ff','#f6fffe','#fff6fd','#fffbf7','#fefff4','#f7fdff ','#fff5f5','#fcfff1','#fff8ff',
        '#f6fffe','#fff6fd','#fffbf7','#fefff4','#f7fdff ','#fff5f5','#fcfff1','#fff8ff','#f6fffe','#fff6fd','#fffbf7','#fefff4',
    ] 
    function randomNumberInRange(min, max) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }
    return ( 
        <section className={Style.category}>
            { 
                props.data.map((item,index)=>
                supplierId===undefined?
                   <Link to={{pathname:`/products/${item.category_english}`,state:item}} 
                    key={item.id} className={Style.itemPart} style={{backgroundColor:`${colorList[index]}`}} >
                        <div className={Style.picHolder} style={{backgroundColor:`${colorList[index]}`}}>
                            <img src={`//cdn.barest.ir/category/${item.id}.jpg?${randomNumberInRange(1, 1000000000000)}`} alt="دسته بندی فروشگاه"/>
                        </div>
                        <h3 className={Style.underText}>{item.category_persian}</h3>
                    </Link> 
                    :
                    <Link to={{pathname:`/products/${item.category_english}/${supplierId}`,state:item}} 
                    key={item.id} className={Style.itemPart} style={{backgroundColor:`${colorList[index]}`}} >
                        <div className={Style.picHolder} style={{backgroundColor:`${colorList[index]}`}}>
                            <img src={`//cdn.barest.ir/category/${item.id}.jpg`} alt="دسته بندی فروشگاه"/>
                        </div>
                        <h3 className={Style.underText}>{item.category_persian}</h3>
                    </Link> 
                )
            }
        </section>
    )
}
export default Grouping
